import { useTranslation } from 'next-i18next'
import styled from 'styled-components'

import { useStateData } from '@/lib/locations'
import { isEmptyOrNull } from '@/utils'
import { toUnit } from '@/utils/styles'
import Breadcrumbs from '@/components/breadcrumbs'

const BreadcrumbWrapper = styled.div`
  padding-bottom: ${props => toUnit(props.bottom) || 0};
`

const CityBreadcrumbs = ({
  cityData,
  neighborhoodData = {},
  loading,
  filterSlug = '',
  bottom = 16
}) => {
  const { t } = useTranslation()
  const stateData = useStateData(cityData.state)

  const noCityData = isEmptyOrNull(cityData)
  if (noCityData) return null

  const stateBreadcrumb = !isEmptyOrNull(stateData)
    ? [
        {
          label: stateData.shortName,
          path: `/rental-listings/${stateData.slug}`
        }
      ]
    : []

  const cityBreadcrumb = [
    {
      label: cityData.translated,
      path: `/rental-listings/city/${cityData.slug}`,
      shallow: true
    }
  ]

  const neighborhoodBreadcrumb = !isEmptyOrNull(neighborhoodData)
    ? [
        {
          label: neighborhoodData.translated,
          path: `/rental-listings/city/${cityData.slug}/${neighborhoodData.slug.slug_name}`,
          shallow: true
        }
      ]
    : []

  const filterBreadcrumb = filterSlug
    ? [
        {
          label: t(`filters:b.listing.view.${filterSlug}.text`, filterSlug),
          path: `/rental-listings/city/${cityData.slug}/${filterSlug}`,
          shallow: true
        }
      ]
    : []

  const breadcrumbs = [
    { label: t('states:Home'), path: '/' },
    ...stateBreadcrumb,
    ...cityBreadcrumb,
    ...neighborhoodBreadcrumb,
    ...filterBreadcrumb
  ]

  return (
    <BreadcrumbWrapper bottom={bottom}>
      <Breadcrumbs items={breadcrumbs} loading={loading} />
    </BreadcrumbWrapper>
  )
}

export default CityBreadcrumbs
